import { render, staticRenderFns } from "./geneldevreraporu.vue?vue&type=template&id=f05477a4&scoped=true"
import script from "./geneldevreraporu.vue?vue&type=script&lang=js"
export * from "./geneldevreraporu.vue?vue&type=script&lang=js"
import style0 from "./geneldevreraporu.vue?vue&type=style&index=0&id=f05477a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05477a4",
  null
  
)

export default component.exports